import { getRequestMyRequests, RequestResponse } from "@api";
import { FilterType, Table } from "@components";
import { Box } from "@material-ui/core";
import { formatDate, formatDate2 } from "@utils";
import * as React from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Cell, Row } from "../../../components/table/types";
import { TABLE_HEADERS, TOOLTIPS } from "../constants";

const headers: Cell[] = [
  { data: TABLE_HEADERS.REF_NUMBER },
  { data: TABLE_HEADERS.RF_NO },
  { data: TABLE_HEADERS.EFFECTIVE_DATE },
  { data: TABLE_HEADERS.STATUS },
  { data: TABLE_HEADERS.USER },
  { data: TABLE_HEADERS.REQUEST_TYPE },
  { data: TABLE_HEADERS.SYSTEM_CATEGORY },
  { data: TABLE_HEADERS.DEVICE_TYPE },
  {
    data: TABLE_HEADERS.NAME,
    tooltip: TOOLTIPS.NAME,
  },
  { data: TABLE_HEADERS.ENVIRONMENT },
  { data: TABLE_HEADERS.ROLE },
];

export const MyRequest: React.FC = () => {
  const [requests, setRequests] = useState<Row<RequestResponse>[]>([]);
  const history = useHistory();
  const [isLoading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    getRequestMyRequests().then((req: RequestResponse[]) => {
      setRequests(
        req.map((r: RequestResponse, index) => {
          return {
            cells: [
              {
                data: r.referenceNumber,
                color: "blue",
                cursor: "pointer",
                onClick: () => {
                  history.push(`/dashboard/requests/${r.encryptId}`, {
                    readonlyAttestation: true,
                    prevPage: "MY-REQUEST",
                  });
                },
              },
              { data: r.rfNo },
              { data: formatDate2(r.effectiveDate) },
              { data: r.status },
              { data: r.userName },
              { data: r.requestType },
              { data: r.category },
              { data: r.deviceType },
              { data: r.subCategory },
              { data: r.environment },
              { data: r.roleName },
            ],
            data: r,
          };
        })
      );
      setIsloading(false);
    });
  }, [history]);

  return (
    <Box mt={2}>
      <Table
        data={requests}
        tableName={"My Requests"}
        searchPlaceholder="Search by Reference N"
        searchColumns={[TABLE_HEADERS.REF_NUMBER, TABLE_HEADERS.STATUS]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="MY_REQUEST_TOOLBAR"
        loading={isLoading}
        order="desc"
      />
    </Box>
  );
};
